import DatePickerFieldAttribute from "/app/javascript/bundles/KeenformRenderer/components/formelements/DatePickerFieldAttribute/DatePickerFieldAttribute";

export default class DatePickerFieldEditor extends DatePickerFieldAttribute{

}